import types from "./types";

const initialState = {
    cardInfo: {},
    updateCardInfo: {},
    paymentMethod: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
    switch (action.type) {
        case types.GET_SUBSCRIPTION_CARD_INFO_RES:
            return {
                ...state,
                cardInfo: action.payload
            }
        case types.GET_SUBSCRIPTION_CARD_INFO_CLEAR:
            return {
                ...state,
                cardInfo: {}
            }
        case types.UPDATE_SUBSCRIPTION_CARD_INFO_RES:
            return {
                ...state,
                updateCardInfo: action.payload
            }
        case types.UPDATE_SUBSCRIPTION_CARD_INFO_CLEAR:
            return {
                ...state,
                updateCardInfo: {}
            }
        case types.PAYMENT_METHOD_DETAIL:
            return {
                ...state,
                paymentMethod: action.payload
            }
        case types.PAYMENT_METHOD_DETAIL_CLEAR:
            return {
                ...state,
                paymentMethod: {}
            }
        default:
            return state
    }
}